import React from "react";
import styled, { withTheme } from "styled-components";

const StyledAlert = styled.div`
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border-radius: 0.25rem;
  background-color: ${(props) =>
    selectBodyColor(props, "background-color", props.type)};
  border-color: ${(props) =>
    selectBodyColor(props, "border-color", props.type)};
  box-shadow: ${(props) => props.theme?.defaultShadow};
  color: ${(props) => props.theme?.nero};
`;

const StyledAlertSquare = styled.div`
  min-width: 20px;
  height: 20px;
  border-radius: 5px;
  margin-top: 2px;
  background-color: ${(props) => selectIconBackground(props, props.type)};
`;

const StyledAlertIcon = styled.div`
  color: ${(props) => props.theme?.white};
  position: absolute;
  text-align: center;
  padding-left: 0.5em;
  top: 15px;
  font-size: 0.8rem;
`;

const selectBodyColor = (props, target, type) => {
  if (
    (target === "background-color" && type === "danger") ||
    (target === "border-color" && type === "danger")
  ) {
    return props.theme?.mistyRose;
  } else if (
    (target === "background-color" && type === "warning") ||
    (target === "border-color" && type === "warning")
  ) {
    return props.theme?.lemon;
  }
};

const selectIconBackground = (props, type) => {
  if (type === "danger") {
    return props.theme?.cardinal;
  } else if (type === "warning") {
    return props.theme?.brightSun;
  }
};

const selectIcon = (type) => {
  if (type === "danger") {
    return "fas fa-times";
  } else if (type === "warning") {
    return "fas fa-exclamation";
  }
};

const AlertUGNX = (props) => {
  const { text, type } = props;

  return (
    <StyledAlert {...props} className="d-flex">
      <StyledAlertSquare {...props} className="mr-2">
        <StyledAlertIcon>
          <i className={selectIcon(type)}></i>
        </StyledAlertIcon>
      </StyledAlertSquare>
      {text || props.children}
    </StyledAlert>
  );
};

export default withTheme(AlertUGNX);
